import React, {Component} from "react";
import Utils from "src/utils/Utils";
import { handleClickRegistraCorreo, handleClickRegistroTelmex, isLandingTelcelButtonEnabled } from "../../utilsLandingTelmex";
import LandingIconButton from "../LandingIconButton/index";
import { REGISTER } from "src/components/Modal/LoginQR/const";
import ButtonPrimary from "../../ButtonPrimary/index";
import { setInitialFocus } from 'src/utils/Utils';

class SectionTelmex extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isTelcelBtnVisible: isLandingTelcelButtonEnabled(),
        }
    }

    componentDidMount() {
        setInitialFocus('.landing-telmex__button-telmex');
    }

    render() {
        const { isTelcelBtnVisible } = this.state;
        const { localAssets, localTranslations } = this.props;
        return(
            <div>
                <img
                    className="landing-telmex__logo"
                    src={localAssets.get('Landing_Logo_ClaroVideo')}
                    alt="Claro Video"
                />
                <div className="landing-telmex__title landing-telmex__title--part-1">
                    {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte1'), 32)}
                </div>
                <div className="landing-telmex__title landing-telmex__title--part-2">
                    {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Titulo_Parte2'), 32)}
                </div>
                <div className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-1">
                    {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte1'), 38)}
                </div>
                <div className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-2">
                    {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte2'), 38)}{' '}
                <span className="landing-telmex__paragraph-1 landing-telmex__paragraph-1--part-3">
                    {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Parrafo1_Parte3'), 38)}
                </span>
                </div>
                <div className="landing-telmex__buttons-container">
                    <LandingIconButton
                        className="landing-telmex__button-telmex"
                        icon={localAssets.get(
                            'Landing_PaginaPrincipal_Boton_Logo_Telmex'
                        )}
                        onClick={() => handleClickRegistroTelmex(this.props)}
                    />

                    {
                        isTelcelBtnVisible && (
                            <LandingIconButton
                                className="landing-telmex__button-telcel"
                                icon={localAssets.get(
                                    'landing_paginaprincipal_boton_logo_telcel'
                                )}
                                onClick={() => {}}
                                onErrorLoadAsset={() => {
                                    this.setState({ isTelcelBtnVisible: false });
                                }}
                            />
                        )
                    }
                </div>
                <div className="landing-telmex__paragraph-2">
                {Utils.cutPlayerString(localTranslations.get('Landing_PaginaPrincipal_Seccion1_Texto_Parrafo2'), 38)}
                </div>
                <ButtonPrimary
                    title={Utils.cutPlayerString(localTranslations.get('Landing_Boton_Texto_RegistrateConCorreo'), 25)}
                    type={REGISTER}
                    onClick={() => handleClickRegistraCorreo(this.props)}
                />
            </div>
        )
    }
}

export default SectionTelmex;



// WEBPACK FOOTER //
// ./src/authentication/components/LandingTelmex/components/SectionTelmex/SectionTelmex.jsx